import { render, staticRenderFns } from "./CombinationsConfiguratorCanvas.vue?vue&type=template&id=46f43730&scoped=true"
import script from "./CombinationsConfiguratorCanvas.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsConfiguratorCanvas.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f43730",
  null
  
)

export default component.exports